/**
 * @Description: 科三考场分类页面
 * @author ZhanFuzheng
 * @date 2022/11/07 11:29:01
*/
<template>
  <div class="wrapper">
    <!--头部-->
    <div class="header">
      <div class="header-left" @click="goBack"><img src="@/assets/public/icon_back.png" alt=""/></div>
      <div class="header-main">科三考场</div>
      <div class="header-right" @click="pushCusService">
          <img src="@/assets/public/icon_customerservice.png" alt=""/>
      </div>
    </div>

    <div class="category">
        <div class="tips">
            <img src="@/assets/examVideoV2/icon_wxtstb@2x.png">
            <p>温馨提示：购买考场视频后可查看您所选择的单个考场下包含的所有路线视频，请选择正确的考场进行购买哦~</p>
        </div>
        <div class="category-wrap">
            <div class="city">
                <div v-for="item in categoryItems" :key="item.cityCode" class="city-item" :class="{active: item.cityCode === currentCategory.cityCode}" @click="handleToggleCity(item.cityCode)"><span>{{item.cityName}}</span></div>
            </div>
            <div v-if="currentCategory && currentCategory.examPlaceList && currentCategory.examPlaceList.length" class="category-content">
                <div v-for="item in currentCategory.examPlaceList" :key="item.id" class="category-item" @click="handleToList(item)">
                    <img class="category-item__bg" :src="item.reduceUrl">
                    <div class="category-item__mask">
                        <div class="category-item__name">{{item.name}}</div>
                        <div class="category-item__line">共<span>{{item.count}}</span>条路线</div>
                        <img v-if="item.vipFlag || vipSwitchFlag" class="category-item__type" :src=" item.vipFlag ? require('@/assets/examVideoV2/icon_ykt@2x.png') : require('@/assets/examVideoV2/icon_wkt@2x.png')">
                    </div>
                </div>
            </div>
        </div>
        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" />
    </div>
  </div>
</template>

<script>
import dialog from '@/components/dialog/index.vue'
import { Toast } from 'vant'
export default {
    name: 'examThreeVideoV2Category',
    components: {
        ctlDialog: dialog
    },
    data () {
        return {
            cityCode: '',
            currentCategory: {},
            categoryItems: [],
            parentName: '',
            vipSwitchFlag: false,
            isOpenVip: false,
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    },
    methods: {
        // 返回
        goBack () {
            if (window.history.state && window.history.state.key) {
                this.$router.back()
            } else {
                this.$jsBridge.callBackHandler('returnLastPage')
            }
        },
        // 联系客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 跳转到考场视频列表页面
        handleToList (item) {
            sessionStorage.setItem('s_vip_examPlaceBatchId', item.id)
            sessionStorage.setItem('s_vip_examPlaceCityCode', item.cityCode)

            if (this.$route.query.openType === 'back') {
                this.goBack()
            } else {
                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                this.$api.getRouteVideoList({
                    subject: 3,
                    examPlaceId: this.$route.query.examPlaceId,
                    examPlaceBatchId: item.id
                }).then(res => {
                    Toast.clear()
                    if (res.status) {
                        if (res.result.videoList && res.result.videoList[0]) {
                            this.$jsBridge.callBackHandler('pushVideoDetailPage', { itemJson: JSON.stringify(res.result.videoList[0]), subject: 3 })
                        }
                    } else {
                        Toast(res.message)
                    }
                })
            }
        },
        // 切换城市
        handleToggleCity (cityCode) {
            if (this.cityCode !== cityCode) {
                this.cityCode = cityCode
                this.getCategory()
            }
        },
        // 获取分类
        getCategory () {
            this.$api.getExamPlaceList({
                subject: 3,
                cityCode: this.cityCode
            }).then(res => {
                if (res.status) {
                    const { examPlaceList, disableMessage, vipSwitchFlag, vipFlag } = res.result
                    if (vipFlag && vipSwitchFlag && disableMessage) {
                        this.messageDialog = {
                            visible: true,
                            rightBtnName: '我知道了',
                            rightBtnMethod: () => {
                                this.messageDialog.visible = false
                            },
                            title: '提示',
                            content: disableMessage
                        }
                    }
                    this.vipSwitchFlag = vipSwitchFlag
                    this.isOpenVip = vipFlag
                    if (examPlaceList && examPlaceList.length) {
                        const arr = []
                        this.currentCategory = examPlaceList.find(({ cityCode }) => (cityCode === this.cityCode)) || examPlaceList[0]
                        this.currentCategory.examPlaceList.forEach(item => {
                            const type = item.vipFlag ? 'unshift' : 'push'
                            arr[type](item)
                        })
                        this.currentCategory.examPlaceList = arr
                        this.categoryItems = examPlaceList
                    }
                } else {
                    Toast(res.message)
                }
            })
        }
    },
    created () {
        this.cityCode = this.$route.query.cityCode || this.$jsBridge.callBackHandler('passRegionCodeData')
        this.getCategory()
    }
}
</script>

<style lang="scss" scoped>
    .wrapper{
        background: #fff;
        .header{
            position: sticky;
            top: 0;
            z-index: 9;
            background: #ffffff;
            display: flex;
            align-items: center;
            padding: 13px 10px;
            .header-left,.header-right{
                display: flex;
                align-items: center;
                width: 100px;
                img{
                    width: 24px;
                }
            }
            .header-right{
                justify-content: end;
                img+img{
                    margin: 0 0 0 13px;
                }
            }
            .header-main{
                text-align: center;
                flex: 1;
                font-size: 18px;
                font-weight: 600;
                color: #333333;
            }
        }
    }
    .category {
        .tips{
            display: flex;
            align-items: flex-start;
            padding: 5px 15px;
            color: #666;
            background-color: #FEF7EF;
            img {
                margin-top: 2px;
                margin-right: 4px;
                width: 12px;
                height: 12px;
            }
            p {
                flex: 1;
                font-size: 12px;
                line-height: 19px;
            }
        }
        h3 {
            color: #333333;
            font-size: 24px;
            font-weight: 600;
            line-height: 1;
            text-align: center;
        }
        .small {
            margin-top: 10px;
            color: #999;
            font-size: 14px;
            font-weight: 400;
            line-height: 1;
            text-align: center;
        }
        .city {
            padding-top: 5px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            white-space: nowrap;
            &-item{
                margin:0 10px 20px;
                color: #333333;
                font-size: 15px;
                font-weight: 400;
                transition: all 0.5s ease;
                &.active{
                    position: relative;
                    font-weight: 600;
                    transform: scale(1.05);
                    &::after{
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 5px;
                        background: #53CB85;
                        border-radius: 3px;
                    }
                    span{
                        position: relative;
                        z-index: 2;
                    }
                }
            }
        }
        &-wrap {
            padding: 0 20px 20px;
        }
        &-content {
            display: flex;
            flex-wrap: wrap;
        }
        &-item {
            margin-bottom: 15px;
            position: relative;
            flex: 0 0 calc( 50% - 7.5px );
            height: 100px;
            line-height: 1;
            background: #000000;
            border-radius: 5px;
            overflow: hidden;
            &__bg {
                width: 100%;
                height: 100%;
                vertical-align: middle;
            }
            &__mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,0.5);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #fff;
            }
            &__name{
                font-weight: 600;
                font-size: 15px;
            }
            &__line{
                margin-top: 5px;
                font-size: 12px;
                span{
                    color: #FF5050;
                }
            }
            &__type{
                position: absolute;
                top: 0;
                right: 0;
                width: 52px;
                height: 16px;
            }
            &:nth-child(odd){
                margin-right: 7.5px;
            }
            &:nth-child(even){
                margin-left: 7.5px;
            }
        }
    }
</style>
